@if (status === 'approved') {
<app-button
  [btnClass]="'btn btn-outline-danger btn-icon-square-outlined'"
  [iconClass]="'fas fa-trash'"
  [ariaLabel]="'admin.common.delete' | translate"
  [loading]="isLoading()"
  [disabled]="isLoading()"
  (clicked)="onDelete()"
/>
}
